<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function updateShowAllTab(value: boolean) {
  await settingsStore.set('worksheetsShowAllTab', value);

  if (value === false && settingsStore.settings.worksheetsStartTab === StartTabSetting.all) {
    await settingsStore.set('worksheetsStartTab', StartTabSetting.mine);
  }
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.worksheetsShowAllTab"
    :label="t('settings.worksheets.showAllTab')"
    :description="t('settings.worksheets.showAllTabDescription')"
    @change="updateShowAllTab"
  />
</template>

<style scoped></style>
